import bigInt from "big-integer";
import config from "../configure/config";
import { toFixed } from "../constants/constants";
import { expandFixed } from "../components/stake/constants/constants";

export const validateUserBalance = async (
  account,
  tokenAddress,
  themeType,
  web3,
  tokenDecimals,
  hardCapInWei,
  liquidityPercentageAllocation,
  listingPriceInWei,
  tokenPriceInWei
) => {
  const abi = config[themeType].ERC20Abi;
  const erc20Contract = new web3.eth.Contract(abi, tokenAddress);

  let balance = await erc20Contract.methods.balanceOf(account.address).call();
  balance = bigInt(balance);

  // Calculating the required balance
  const decimals = bigInt(10).pow(tokenDecimals);
  const hardCap = expandFixed(hardCapInWei, tokenDecimals);
  const liquidityAllocation = bigInt(liquidityPercentageAllocation);
  const tokenPrice = expandFixed(tokenPriceInWei, tokenDecimals);

  const maxTokensToBeSold = hardCap.multiply(decimals).divide(tokenPrice);

  let requiredBalance = maxTokensToBeSold;

  if (Number(listingPriceInWei) > 0) {
    const listingPrice = expandFixed(listingPriceInWei, tokenDecimals);
    const maxLiqPoolTokenAmount = hardCap
      .multiply(liquidityAllocation)
      .multiply(decimals)
      .divide(listingPrice.multiply(bigInt(100)));

    requiredBalance = maxLiqPoolTokenAmount.add(maxTokensToBeSold);
  }

  const hasEnoughBalance = balance.greaterOrEquals(requiredBalance);

  return [
    hasEnoughBalance,
    parseFloat(toFixed(bigInt(requiredBalance), Number(tokenDecimals), 3)),
  ];
};
